
import { ref, useContext, useRoute } from '@nuxtjs/composition-api';
import tinycolor from 'tinycolor2';
import useSearch from '@/composable/useSearch';
import useCategories from '@/composable/useCategories';
import useTracking from '@/composable/tracking/useTracking'

export default {
  props: {
    searchResult: {
      type: Object,
      default: () => {}
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    const categories = ref([]);
    const categoryTree = ref([]);
    const { state, isBooleanFilter } = useSearch(context)
    const { app } = useContext()
    const route = useRoute()
    const { getCategoryTree, getCategories, getCategoryBySlug } = useCategories(app.$hubble);
    const { track } = useTracking()


    const catsWithoutSubCat = ref(null)
    const subCategories = ref(null)
    const categorySlug = route.value.params.categoryslug
    const callCategories = async () => {
      await getCategories()
      const category = await getCategoryBySlug(categorySlug);
      categoryTree.value = await getCategoryTree(category?.id)
      catsWithoutSubCat.value = getCatsWithoutSubCat()
      subCategories.value = getSubCategories()
    }

    const getCatsWithoutSubCat = () => {
      if (categoryTree.value.length > 0) {
        return categoryTree.value.filter(cat => cat.children.length === 0).sort((a, b) => a.orderHint - b.orderHint)
      }
      return null
    }

    const getSubCategories = () => {
      if (categoryTree.value.length > 0) {
        categoryTree.value.find(cat => cat.children.length > 0).children.forEach(subcat => subcat.children.sort((a, b) => a.orderHint - b.orderHint))
        return categoryTree.value.find(cat => cat.children.length > 0).children.sort((a, b) => a.orderHint - b.orderHint)
      }
      return null
    }

    const isSubCatValidCache = {}
    const isSubCatValid = (subCatID, filterName) => {
      if (isSubCatValidCache[subCatID + filterName]) {
        return isSubCatValidCache[subCatID + filterName]
      }
      isSubCatValidCache[subCatID + filterName] = props.searchResult.data.aggregations[filterName].buckets.find(bucket => bucket.key === subCatID) !== undefined
      return isSubCatValidCache[subCatID + filterName]
    }
    callCategories()

    return {
      state,
      track,
      isBooleanFilter,
      categories,
      subCategories,
      catsWithoutSubCat,
      isSubCatValid
    }
  },
  data () {
    return {
      panelModel: [],
      subCatPanelModel: []
    }
  },
  mounted () {
    this.panelModel = [0]
  },
  methods: {
    isLightColor(value) {
      const color = tinycolor(value);
      return color.isLight()
    },
    parentSubCatChosen (event, bucket, filterName) { // when a brand in passer til is chosen, the children should also be handled
      if (event.includes(bucket.id)) { // parent category is chosen so include child categories as well
        bucket.children.forEach(child => { // but add only if the child is not already present in the selected filters
          if (!this.state.searchFilters.value[filterName].includes(child.id) && this.isSubCatValid(child.id, filterName)) {
            this.state.searchFilters.value[filterName].push(child.id)
          }
        })
      } else {
        bucket.children.forEach(child => { // parent category is not chosen so exclude child categories as well
          const indexToBeRemoved = this.state.searchFilters.value[filterName].indexOf(child.id)
          this.state.searchFilters.value[filterName].splice(indexToBeRemoved, 1)
        })
      }
      this.filterChanged({ event, filterName, bucket, name: bucket.name })
    },
    childSubCatChosen (event, bucket, filterName, name) {
      if (event.includes(bucket.id)) {
        const indexToBeRemoved = this.state.searchFilters.value[filterName]?.indexOf(bucket.id)
        this.state.searchFilters.value[filterName].splice(indexToBeRemoved, 1)
      }
      this.filterChanged({ event, filterName, bucket, name })
    },
    filterChanged ({ event, filterName, bucket, name, filter }) {
      this.$nuxt.$emit('filters-changed', { event, filterName })
      this.track('filterChanged', { event, filterName, bucket: bucket || filter.buckets[0], name })
    },
    getFiltered (filter) {
      return filter.buckets.filter(item => item.selected).length
    },
    getFilterTitle (filter) {
      return this.isBooleanFilter(filter.name) ? 'Andet' : filter.title
    },
    itemsSelected (filter) {
      return filter.buckets.filter(item => item.selected).length !== 0 && this.isMobile
        ? '(' + filter.buckets.filter(item => item.selected).length + ')'
        : ''
    },
    catsWithoutSubCatSelected (filterItem) {
      // count the number of "Kategori" filters - these are the sub categories of accessories but have no further sub categories
      return this.catsWithoutSubCat !== null && filterItem.buckets.filter(item => {
        const val = this.catsWithoutSubCat.filter(cat => cat.id === item.key).length > 0
        return item.selected && val
      }).length !== 0
        ? '(' + filterItem.buckets.filter(item => item.selected && this.catsWithoutSubCat.filter(cat => cat.id === item.key).length > 0).length + ')'
        : ''
    },
    catsWithSubCatSelected (filter) {
      // count the number of passer til categories and sub categories are selected
      const filterItem = this.searchResult?.data?.aggregations[filter.name]?.buckets
      return this.subCategories !== undefined && this.subCategories !== null && filterItem !== undefined && filterItem.filter(item => {
        const val = this.subCategories.filter(cat => cat.id === item.key || cat.children.filter(subCat => subCat.id === item.key)).length > 0
        return item.selected && val
      }).length !== 0
        ? '(' + filterItem.filter(item => item.selected && this.subCategories.filter(cat => cat.id === item.key || cat.children.filter(subCat => subCat.id === item.key)).length > 0).length + ')'
        : ''
    }
  }
}
